import React, { useEffect } from "react";
import { Divider } from "rsuite";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Navigation from "../components/Navigation";
import SocialIcons from "../components/SocialIcons";
import Sitemap from "../components/Sitemap";
import PhotoFrame from "./PhotoFrame";

function replaceBackslashes(url) {
  return url.replace(/\\/g, "/");
}

const Page = ({
  picture,
  pageTitle,
  title,
  children,
  linkTitle,
  links,
  date,
  height,
  image = true,
  showFrame = false,
}) => {
  const path = useLocation().pathname;
  const navigate = useNavigate();
  useEffect(() => {
    const body = document.querySelector("#root");
    body.scrollIntoView(
      {
        behavior: "smooth",
      },
      500
    );
  }, []);

  const project = links
    .filter((link) => path == link.path)
    .map((link) => link.title)[0];

  return (
    <Container>
      <Navigation transparent={image ? true : false} />
      {image ? (
        <ImageContainer>
          <Image
            src={replaceBackslashes(picture)}
            alt=""
            imgheight={height}
            loading="lazy"
          />
        </ImageContainer>
      ) : (
        <Spacer />
      )}
      <Main>
        <PageTitle>{pageTitle}</PageTitle>
        <Description>{date}</Description>
        <SocialIcons />
        <Divider />
        <Layout>
          <Content>
            <Title>{title}</Title>
            <Body>{children}</Body>
            {showFrame ? (
              <PhotoFrame
                width="100%"
                src={encodeURI(picture)}
                title={project}
                btnTitle={"Learn More..."}
                onClick={() =>
                  navigate(`/news/${project}`, { state: { image: picture } })
                }
              />
            ) : null}
          </Content>
          <Links>
            <LinkContainer>
              <LinkTitle>{linkTitle}</LinkTitle>
              {links.map((item) => {
                return (
                  <LinkItem to={item.path} activepath={path === item.path}>
                    {item.title}
                  </LinkItem>
                );
              })}
            </LinkContainer>
          </Links>
        </Layout>
      </Main>
      <Sitemap />
    </Container>
  );
};

export default Page;

let Container = styled.div`
  width: 100vw;
  height: 100vh;
`;

let Main = styled.div`
  width: 100%;
  padding: 40px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Body = styled.div`
  /* padding-right: 25px; */
  box-sizing: border-box;
`;

let PageTitle = styled.span`
  font-size: 2rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #252528;
`;

let Title = styled.div`
  font-family: "Poppins";
  font-weight: 700;
  color: #252528;
  font-size: 1.5rem;
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: wrap;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

let ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 500px;
  background-color: grey;
  overflow: hidden;
  transition: all 250ms ease-in-out;
  &:hover {
    height: 800px;
  }
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    &:hover {
      height: auto;
    }
  }
`;

let Image = styled.div`
  width: 100%;
  background-image: ${(props) => `url(${props.src})`};
  height: ${(props) => (props.imgheight ? props.imgheight : "500px")};
  /* object-fit:cover; */
  object-position: center;
  background-size: cover;
  background-repeat: repeat-x;
  background-position: 50%;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  z-index: 0;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  &:hover {
    height: 800px;
  }

  &:before {
    background: rgba(0, 0, 0, 0.4);
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    max-height: 280px;
    min-height: 200px;
    background-attachment: scroll;
    &:hover {
      height: auto;
    }
  }
`;

let Layout = styled.div`
  display: grid;
  grid-template-columns: 2fr 0.6fr;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

let Content = styled.div`
  padding-right: 40px;
  box-sizing: border-box;
  @media (max-width: 768px) {
    padding-right: 10px;
  }
`;

let Links = styled.div`
  border-left: 1px solid #c6c661;
  @media (max-width: 768px) {
    border-left: none;
  }
`;

let LinkTitle = styled.div`
  font-size: 1.4rem;
  font-family: "Poppins";
  font-weight: 700;
`;

let LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: 15px;
  box-sizing: border-box;
  line-height: 30px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 30px;
    height: auto;
    /* padding: 20px; */
    line-height: 30px;
    padding: 0px;
  }
`;

const LinkItem = styled(Link)`
  color: #000;
  margin-left: 10px;
  font-weight: ${(props) => (props.activepath ? "bold" : "")};
  :hover {
    text-decoration: none;
  }
  ::before {
    content: "•";
    margin-right: 10px;
    position: relative;
    top: 4px;
    font-size: 1.7rem;
    color: #c6c661;
  }
  @media (max-width: 768px) {
    border-bottom: 1px solid #c6c661;
    margin-left: 0px;
  }
`;

let Description = styled.div`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 1rem;
  margin-block: 5px;
  color: #222222;
`;

const Spacer = styled.div`
  height: 80px;
  width: 100%;
`;
